// src/Layout/AppHeader/Header.js  (or wherever your Header is)
import React, { Fragment, useEffect, useState } from "react";
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { Dropdown } from 'react-bootstrap';
import cx from "classnames";
import { useCompany } from "../../companycontext/index";  // ← IMPORTANT
import API_URLS from "../../summaryapi/apiUrls";
import dhanashakthi from "../../assets/images/dhanashakthi.png";

const CompanyDropdown = ({ companies, selectedCompany, setSelectedCompany }) => (
  <Dropdown>
    <Dropdown.Toggle variant="light" size="sm" style={{ minWidth: '200px', fontWeight: '500' }}>
      {selectedCompany
        ? companies.find(c => c.guid === selectedCompany)?.company_name || "Loading..."
        : "Select Company"}
    </Dropdown.Toggle>

    <Dropdown.Menu style={{ maxHeight: '300px', overflowY: 'auto' }}>
      {companies.map(company => (
        <Dropdown.Item
          key={company.guid}
          active={selectedCompany === company.guid}
          onClick={() => setSelectedCompany(company.guid)}
        >
          {company.company_name}
        </Dropdown.Item>
      ))}
    </Dropdown.Menu>
  </Dropdown>
);

const Header = () => {
  const { selectedCompany, setSelectedCompany } = useCompany(); // ← Use Context!
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCompanies = async () => {
      try {
        const res = await fetch(API_URLS.getActivecompany.url);
        const json = await res.json();
        if (json.status && json.data) {
          setCompanies(json.data);

          // Auto-select first company if none selected
          if (!selectedCompany && json.data.length > 0) {
            setSelectedCompany(json.data[0].guid);
          }
        }
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchCompanies();
  }, [selectedCompany, setSelectedCompany]);

  const adminMode = sessionStorage.getItem("adminMode") 
    ? atob(sessionStorage.getItem("adminMode")) 
    : null;

  return (
    <Fragment>
      <TransitionGroup>
        <CSSTransition
          component="div"
          className={cx("app-header")}
          appear={true}
          timeout={1500}
          enter={false}
          exit={false}
          style={{
            background: "linear-gradient(135deg,rgb(172,37,44),rgb(235,45,64),rgb(172,35,35))"
          }}
        >
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            padding: '15px 20px',
            position: 'relative'
          }}>
            {/* Logo + Title */}
            <div style={{
              position: 'absolute',
              left: '50%',
              transform: 'translateX(-50%)',
              display: 'flex',
              alignItems: 'center',
              gap: '15px'
            }}>
              <img src={dhanashakthi} alt="Logo" style={{ width: '160px', height: '40px' }} />
              <h3 style={{ margin: 0, color: '#fff', fontSize: '18px', fontWeight: '600' }}>
                {adminMode && !["Admin", "Employee"].includes(adminMode) 
                  ? `${adminMode} Admin Dashboard` 
                  : ""}
              </h3>
            </div>

            {/* Company Switcher */}
            <div style={{
              position: 'absolute',
              left: '50%',
              transform: 'translateX(150px)'
            }}>
              {loading ? (
                <span style={{ color: 'white' }}>Loading companies...</span>
              ) : (
                <CompanyDropdown
                  companies={companies}
                  selectedCompany={selectedCompany}
                  setSelectedCompany={setSelectedCompany}
                />
              )}
            </div>
          </div>
        </CSSTransition>
      </TransitionGroup>
    </Fragment>
  );
};

export default Header;